import React from 'react';
import { Dialog, IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { formatReportValue } from '../constants';
import * as Style from './SSSGDetailsModal.styles';

function KvItem({ label, value, format, negativeIfBelowZero }) {
    const isNegative = negativeIfBelowZero && value < 0;
    return (
        <Style.KvItem>
            <Style.KvLabel>{label}</Style.KvLabel>
            <Style.KvValue negative={isNegative}>
                {formatReportValue(value, format)}
            </Style.KvValue>
        </Style.KvItem>
    );
}

function KvCard({ title, headerExtra, compact, children }) {
    return (
        <Style.KvCard compact={compact}>
            <Style.KvCardHeader>
                <Style.KvCardTitle>{title}</Style.KvCardTitle>
                {headerExtra}
            </Style.KvCardHeader>
            <Style.KvCardDivider />
            <Style.KvGrid>{children}</Style.KvGrid>
        </Style.KvCard>
    );
}

function SSSGDetailsModal({ open, onClose, variant, sellerName, details }) {
    const sssgGeral = details?.sssgGeral || {};
    const sssgOnOff = details?.sssgOnOff || {};
    const valoresAnoPassado = details?.valoresAnoPassado || {};
    const valoresEsperados = details?.valoresEsperados || {};
    const outrosValores = details?.outrosValores || {};
    const compact = variant !== 'store';

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                elevation: 0,
                style: {
                    width: variant === 'store' ? '811px' : '520px',
                    borderRadius: '14px',
                    maxWidth: '90vw',
                    maxHeight: 'calc(100vh - 96px)',
                    backgroundColor: '#212121',
                    backgroundImage: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                },
            }}
        >
            <Style.ModalHeader>
                <Style.ModalTitle compact={variant !== 'store'}>
                    {variant === 'store'
                        ? 'Detalhes SSSG'
                        : `Detalhes SSSG · ${sellerName}`}
                </Style.ModalTitle>
                <IconButton size="small" onClick={onClose}>
                    <Close style={{ color: '#DCC6B7' }} />
                </IconButton>
            </Style.ModalHeader>

            <Style.ModalBody>
                <KvCard title="SSSG Geral" compact={compact}>
                    <KvItem
                        label="SSSG"
                        value={sssgGeral.sssg}
                        format="percent"
                    />
                    <KvItem
                        label="Projeção %"
                        value={sssgGeral.projecao}
                        format="percent"
                    />
                </KvCard>

                <KvCard title="SSSG ON/OFF" compact={compact}>
                    <KvItem
                        label="SSSG ON"
                        value={sssgOnOff.on}
                        format="percent"
                        negativeIfBelowZero
                    />
                    <KvItem
                        label="SSSG OFF"
                        value={sssgOnOff.off}
                        format="percent"
                        negativeIfBelowZero
                    />
                </KvCard>

                <KvCard
                    title="Valores Ano Passado"
                    compact={compact}
                    headerExtra={
                        <Style.InlineKv>
                            <Style.KvLabel>Total Last Year</Style.KvLabel>
                            <Style.KvValue>
                                {formatReportValue(
                                    valoresAnoPassado.totalLastYear,
                                    'number'
                                )}
                            </Style.KvValue>
                        </Style.InlineKv>
                    }
                >
                    <KvItem
                        label="Venda ON"
                        value={valoresAnoPassado.vendaOn}
                        format="number"
                    />
                    <KvItem
                        label="Venda OFF"
                        value={valoresAnoPassado.vendaOff}
                        format="number"
                    />
                </KvCard>

                <KvCard title="Valores Esperados" compact={compact}>
                    <KvItem
                        label="Esperado ON"
                        value={valoresEsperados.esperadoOn}
                        format="number"
                    />
                    <KvItem
                        label="Esperado OFF"
                        value={valoresEsperados.esperadoOff}
                        format="number"
                    />
                </KvCard>

                <KvCard title="Outros Valores" compact={compact}>
                    <KvItem
                        label={variant === 'store' ? 'Loja' : 'Salão'}
                        value={outrosValores.loja}
                        format="number"
                    />
                    <KvItem
                        label="Agenda"
                        value={outrosValores.agenda}
                        format="number"
                    />
                    <KvItem
                        label="Código"
                        value={outrosValores.codigo}
                        format="number"
                    />
                    <KvItem
                        label="Mala"
                        value={outrosValores.mala}
                        format="number"
                    />
                </KvCard>
            </Style.ModalBody>
        </Dialog>
    );
}

export default SSSGDetailsModal;
